import { actionHandler } from "../api";
const profileSummaryURL = `api/method/guidestar.api.npo_profile_summary_page.get_npo_profile_summary`;
const programsAndResultsURL = `api/method/guidestar.api.npo_profile_programme_page.get_npo_profile_programmes`;
const governanceURL = `api/method/guidestar.api.npo_profile_governance_page.get_npo_profile_governance`;
const financeURL = `api/method/guidestar.api.npo_profile_finance_page.get_npo_profile_finance`;
const operationsURL = `api/method/guidestar.api.npo_profile_operations_page.get_npo_profile_operations`;
const documentsURL = `api/method/guidestar.api.npo_profile_document_page.get_npo_profile_documents`;
const getProfileUrls = `api/method/guidestar.api.npo_profile.npo_urls`;

const getNpoProfileSummary = async (orgName) => {
  try {
    const response = await actionHandler({
      url: `${profileSummaryURL}?args={"name":"${orgName}"}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getNpoProgramsAndResults = async (orgName) => {
  try {
    const response = await actionHandler({
      url: `${programsAndResultsURL}?args={"name":"${orgName}"}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getNpoGovernanceDetails = async (orgName) => {
  try {
    const response = await actionHandler({
      url: `${governanceURL}?args={"name":"${orgName}"}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getNpoFinanceDetails = async (orgName) => {
  try {
    const response = await actionHandler({
      url: `${financeURL}?args={"name":"${orgName}"}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getNpoOperationsDetails = async (orgName) => {
  try {
    const response = await actionHandler({
      url: `${operationsURL}?args={"name":"${orgName}"}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getNpoDocuments = async (orgName) => {
  try {
    const response = await actionHandler({
      url: `${documentsURL}?args={"name":"${orgName}"}`,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getUrlList = async () => {
  try {
    const response = await actionHandler({
      url: getProfileUrls,
      method: 'GET'
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};



export {
  getNpoProfileSummary,
  getNpoProgramsAndResults,
  getNpoGovernanceDetails,
  getNpoFinanceDetails,
  getNpoOperationsDetails,
  getNpoDocuments,
  getUrlList
};

